import { InputsFinalize } from "../components/FinalizePage/FinalizeNoLogin";
import { FinalizeRecipient } from "./FinalizeRecipient";

export interface SaveData {
  name: string;
  lastName: string;
  email: string;
  phone: string;
  city: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  zipCode: string;
  NIP: string;
  companyName: string;
  createUser: boolean;
  createInvoice: boolean;
  recipient?: FinalizeRecipient;
  purchaser?: FinalizeRecipient;
}

export const setSaveData = (data: InputsFinalize) => {
  return {
    name: data.firstName ?? "",
    lastName: data.lastName ?? "",
    email: data.email ?? "",
    phone: data.phone ?? "",
    city: data.city ?? "",
    street: data.street ?? "",
    houseNumber: data.houseNumber ?? "",
    flatNumber: data.flatNumber ?? "",
    zipCode: data.zipCode ?? "",
    NIP: data.NIP ?? "",
    companyName: data.companyName ?? "",
    createUser: data.createUser ?? false,
    createInvoice: data.createInvoice,
    recipient: data.recipient ?? {},
    purchaser: data.purchaser ?? {},
  } as SaveData;
};
